import { Grid } from "@material-ui/core";
import React from "react";
import { InputFieldFormik, Subtitle } from "ui/componentes";

const AddressProfileForm = ({ disabled = false }) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Subtitle text="Address" />
            </Grid>
            <Grid item xs={12} md={2}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.postalCode"
                    name="privateInfo.address.postalCode"
                    label="Cep"
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.street"
                    name="privateInfo.address.street"
                    label="Logradouro"
                />
            </Grid>
            <Grid item xs={12} md={2}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.number"
                    name="privateInfo.address.number"
                    type="number"
                    label="Número"
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.complement"
                    name="privateInfo.address.complement"
                    label="Complemento"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.neighborhood"
                    name="privateInfo.address.neighborhood"
                    label="Bairro"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.address.state"
                    name="privateInfo.address.state"
                    label="Estado"
                />
            </Grid>
        </Grid>
    );
};

export default AddressProfileForm;
